module.exports = __webpack_public_path__ + "img/sec1_5.e7f620c6.png";